import { AllPlans, Plan } from './Shop.model';
import { useGetAllPlansQuery } from './ShopQuery';
import { useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../api/config';

export function findPlanBySkuSet(
  skuSet: string[],
  plans: AllPlans | undefined,
): Plan | undefined {
  if (!plans || !Array.isArray(plans) || !skuSet || skuSet.length === 0)
    return undefined;

  const planContainsAllSkus = (plan: Plan): boolean => {
    if (!plan.sku_set || !Array.isArray(plan.sku_set)) return false;

    return (
      plan.sku_set.length === skuSet.length &&
      skuSet.every((sku) => plan.sku_set.includes(sku))
    );
  };

  return plans.find(planContainsAllSkus);
}

export function useFindPlanBySkuSet(skuSet: string[]) {
  const { data: plans, isLoading, error } = useGetAllPlansQuery();
  const queryClient = useQueryClient();

  let plan;
  const plansFromCache = queryClient.getQueryData<AllPlans>([
    QUERY_KEYS.SHOP_PAGE_PLANS,
  ]);
  if (plansFromCache) {
    plan =
      skuSet && skuSet.length > 0
        ? findPlanBySkuSet(skuSet, plansFromCache)
        : undefined;
  } else {
    plan =
      skuSet && skuSet.length > 0 ? findPlanBySkuSet(skuSet, plans) : undefined;
  }

  return {
    plan,
    isLoading,
    error,
  };
}
